import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const QuizResultService = sdk.getService('QuizResultService');

export const useQuizResultById = (id: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['quiz-result', id],
    queryFn: () => QuizResultService.getQuizResultDataById(id)
  });

  return {
    data,
    isLoading,
    error
  };
};
